<template>
  <div id="manage">
    <div class="content">
        <div class="title"><span style="color:#c30d23;cursor:pointer;" @click="goback(1)">{{term_name}}</span>  /  学生培训班</div>
        <!-- <div class="top">
            <div class="fl_left">
                <div class="wzbarBox">
                    <div class="wzbar" v-for="(name,index) in items" @click="tab(index,name)" :class="{'wzbars':index==num}">
                        <div>{{name.name}}</div>
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div> -->
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <!-- <div class="fl_left">
                        <Select v-model="levalId" placeholder="请选择级别" class="borDiv" style="width:300px;border:1px solid #e7e7eb;margin:20px 0;" @on-change="search(1)">
                            <Option v-for="item in levelList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div> -->
                    <!-- <div class="fl_right addClass" @click="addRecruit">新增班级</div> -->
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
            <div class="alertBox" v-if="alertShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">{{valm==1?'编辑':'新增'}}</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">班级名称</div>
                            <div class="fl_left inputBox">
                                <Input v-model="name" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入班级名称" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <!-- <div class="list listpad">
                            <div class="fl_left name">舞种</div>
                            <div class="fl_left inputBox">
                                <Select v-model="dance" class="bordiv" placeholder="请选择舞种" filterable @on-change="getLvel(1)" style="width:440px;">
                                 <Option v-for="item in danceList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div> -->
                        <div class="list listpad">
                            <div class="fl_left name">级别</div>
                            <div class="fl_left inputBox">
                                <Select v-model="level_id" class="bordiv" placeholder="请选择级别" filterable style="width:440px;">
                                    <Option v-for="item in levelArr" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">承办单位</div>
                            <div class="fl_left inputBox">
                                <Select v-model="company_id" class="bordiv" placeholder="请选择承办单位" filterable style="width:440px;" @on-change="companyChange">
                                 <Option v-for="item in companyList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad" v-if="is_pay==1">
                            <div class="fl_left name">报名金额</div>
                            <div class="fl_left inputBox">
                                <Input v-model="price" class="bordiv" size="large" autocomplete="off" style="width:440px;" @input="price=price.replace(/[^\d(?:\.\d{1,2})?$]/g,'')" placeholder="请输入报名金额" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">上课日期</div>
                            <div class="fl_left inputBox" style="height: 36px;">
                                <DatePicker 
                                type="daterange" 
                                format="yyyy-MM-dd" 
                                placeholder="请选择上课日期"
                                class="bordiv" 
                                style="width:440px;"
                                :value="classDate"
                                @on-change="dateChange1"
                                :options="options3"
                                >
                                </DatePicker>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">最多申报人数</div>
                            <div class="fl_left inputBox">
                                <Input v-model="maxnum" class="bordiv" size="large" style="width:440px;" placeholder="请输入" />
                                <input type="text" autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        
                    </div>
                    <div class="tanBtn" @click="tanyes(valm)">确定</div>
                </div>
            </div>
            <div class="alertBox" v-if="teaShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">设置</div>
                        <div class="fl_right tandel" @click="teadel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">高教</div>
                            <div class="fl_left inputBox">
                                <Select v-model="teacher_id" class="bordiv" placeholder="请选择高教" filterable style="width:440px;">
                                 <Option v-for="item in teaList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tanBtn" @click="teayes">确定</div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                teaShow:false,
                teaList:'',
                items:[
                    {
                        name:'报名培训中',
                        type:0
                    },
                    {
                        name:'已结束',
                        type:1
                    },
                ],
                start_date:'',
                end_date:'',
                statusList:[],
                statusId:'',
                classDate:[],
                company_id:'',
                companyList:[],
                options3:{},
                name:'',
                keyword:'',
                level_id:'',
                levelArr:[],
                levalId:'',
                levelList:[],
                dance:'',
                danceList:[],
                dance_id:'',
                phone:'',
                teatsex:'0',
                teacher_id:'',
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                stop_reason:'',
                level_idShow:'',
                columns7: [
                    {
                        title: '班级名称',
                        align: 'center',
                        key: 'name',
                    },
                    {
                        title: '舞种',
                        align: 'center',
                        key: 'dance_name',
                    },
                    {
                        title: '级别',
                        align: 'center',
                        key: 'level',
                    },
                    {
                        title: '教师',
                        align: 'center',
                        key: 'user_name',
                        width:160,
                        render: (h, params) => {
                                return h('div',{
                                    style:{
                                        overflow:'hidden',
                                        padding:'10px 0'
                                    }
                                },[
                                    h('img',{
                                        style:{
                                            width:'47px',
                                            height:'60px',
                                            display:'block',
                                            float:'left'
                                        },
                                        domProps: {
                                            src:params.row.avater==''?'static/imgs/logo@3x.png':params.row.avater
                                        }
                                    }),
                                    h('div',{
                                        style:{
                                            width:'80px',
                                            float:'left',
                                            margin:'0px 0 0 11px'
                                        },
                                    },[
                                        h('div',{
                                            style:{
                                                width:'80px',
                                                overflow:'hidden'
                                            },
                                        },[
                                            h('div',{
                                                style:{
                                                    float:'left'
                                                }
                                            },params.row.user_name),
                                        ]),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.cert_num),
                                    ])
                                ]);
                        }
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'created_at',
                    },
                    {
                        title: '报名学员',
                        align: 'center',
                        key:'max_num',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div',params.row.cur_num+'人');
                            // }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要删除这个班级？</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deleteteacherclass',{class_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('删除成功');
                                                                this.search(1);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '删除'),
                                ]);
                            // }
                        }
                    }

                ],
                data6: [],
                alertShow:false,
                valm:0,
                num:0,
                tabId:0,
                maxnum:'',
                term_id:'',
                term_name:'',
                is_pay:'',
                price:'',
            }
        },
        methods:{
            companyChange(value){
                for (var i = 0;i<this.companyList.length;i++) {
                   if(this.companyList[i].id==value) {
                        this.is_pay=this.companyList[i].is_pay;
                   }
                }
            },
            CopyUrl(data){
                var Url2 = document.getElementById("inviteCode").innerText;
                var oInput = document.createElement("input");
                oInput.value = Url2;
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                oInput.className = "oInput";
                oInput.style.display = "none";
                this.$Message.success('复制成功！');
            },
            goback(index){
                if(index==1){
                    this.$router.go(-1);
                }
                if(index==2){
                    this.$router.go(-2);
                }
            },
            dateChange1(value){
                this.classDate=value;
            },
            tab(index,item){
                let _this=this;
                _this.num=index;
                _this.tabId=item.type;
                _this.canpay_name='';
                _this.getscity(0);
            },
            teayes(){
                let _this=this;
                _this.$axios.post('setteacher',{
                    teacher_id:_this.teacher_id,
                    class_id:_this.class_id,
                }).then(res=>{
                    if(res.data.code==200){
                        _this.teaShow=false;
                        _this.search(0);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
                
            },
            teadel(){
                this.teaShow=false;
            },
            tanyes(index){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(_this.name==''){
                    this.$Message.error('请输入班级名称');
                }
                // else if(_this.dance===''){
                //     this.$Message.error('请选择舞种');
                // }
                else if(_this.level_id===''){
                    this.$Message.error('请选择级别');
                }
                else if(_this.company_id===''){
                    this.$Message.error('请选择承办单位');
                }
                else if(_this.is_pay==1 && _this.price===''){
                    this.$Message.error('请输入报名金额');
                }
                else if(_this.classDate.length===0){
                    this.$Message.error('请选择上课日期');
                }
                else if(_this.maxnum===''){
                    this.$Message.error('请填写最多申报人数');
                }
                else{
                    if(index==0){
                        _this.$axios.post('addclass',{
                            term_id:_this.term_id,
                            name:_this.name,
                            dance_id:_this.dance,
                            level_id:_this.level_id,
                            max_num:_this.maxnum,
                            company_id:_this.company_id,
                            start_date:_this.classDate[0],
                            end_date:_this.classDate[1],
                            price:_this.price,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                    if(index==1){
                        _this.$axios.post('editclass',{
                            class_id:_this.class_id,
                            name:_this.name,
                            dance_id:_this.dance,
                            level_id:_this.level_id,
                            max_num:_this.maxnum,
                            company_id:_this.company_id,
                            start_date:_this.classDate[0],
                            end_date:_this.classDate[1],
                            price:_this.price,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                }
            },
            tandel(){
                this.alertShow=false;
            },
            search(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                _this.$axios.post('getteacherclasslist',{
                    page:_this.pageNum,
                    company_id:_this.term_id,
                }).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.pageNum = num;
                this.search(0);
            },
            addRecruit(){
                let _this=this;
                _this.options3={
                    disabledDate (date){
                        return (date && date.valueOf() > new Date(_this.end_date).getTime()) || (date && date.valueOf() < new Date(_this.start_date).getTime() - 86400000);
                    }
                }
                _this.valm=0;
                _this.name='';
                _this.dance='';
                _this.level_id='';
                _this.company_id='';
                _this.classDate=[],
                _this.getLvel();
                _this.getcompany();
                _this.maxnum='';
                _this.alertShow=true;
            },
            getTea(){
                let _this=this; 
                _this.$axios.post('getteacherselect',{level_id:_this.level_idShow}).then(res=>{
                    if(res.data.code==200){
                        _this.teaList=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getstatus(){
                let _this=this; 
                _this.$axios.post('getclassstatus',{}).then(res=>{
                    if(res.data.code==200){
                        _this.statusList=res.data.data;
                        _this.statusId=res.data.data[0].id;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getcompany(){
                let _this=this; 
                _this.$axios.post('getcompanyselect',{}).then(res=>{
                    if(res.data.code==200){
                        _this.companyList=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getprovince(index){
                let _this=this; 
                _this.$axios.post('getdancelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.danceList=res.data.data;
                        _this.dance=res.data.data[0].id;
                        _this.getLvel(index);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getLvel(index){
                let _this=this; 
                _this.$axios.post('getlevellist',{}).then(res=>{
                    if(res.data.code==200){
                        if(index==1){
                            _this.levelArr=res.data.data;
                        }
                        else{
                            _this.level_id=res.data.data[0].id;
                            _this.levelArr=res.data.data;
                        }
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getLvels(){
                let _this=this; 
                _this.getstatus();
                _this.$axios.post('getlevellist',{type:1}).then(res=>{
                    if(res.data.code==200){
                        _this.levelList=res.data.data;
                        _this.levalId=res.data.data[0].id;
                        _this.search(1);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getscity(index){
                let _this=this; 
                _this.$axios.post('getdancelist',{type:index===0?1:''}).then(res=>{
                    if(res.data.code==200){
                        if(res.data.data.length!=0){
                            _this.danceList=res.data.data;
                            _this.dance_id=res.data.data[0].id;
                            _this.getstatus();
                            _this.getLvels(0);
                        }
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
        },
        created(){
            let _this=this; 
            _this.term_id=this.$route.query.term_id;
            _this.term_name=this.$route.query.name;
            let luder=JSON.parse(localStorage.getItem("luder"));
            if(luder!=null){
                _this.getLvels(0);
                _this.pageNum=luder.pageNum; 
                _this.keyword=luder.keyword;
                _this.dance_id=luder.dance_id;
                _this.levelId=luder.levelId;
                _this.statusId=luder.statusId;
                // _this.search(0)
            }
            else{
                _this.getLvels(0);
            }
            
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/company/teacherClass.vue